var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-more"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9933 8.11615C11.9695 8.2928 11.8938 8.45833 11.7776 8.5872L5.40535 15.6976C5.26429 15.8764 5.05997 15.9864 4.84114 15.9986C4.62126 16.012 4.40761 15.9275 4.24788 15.7653C4.08919 15.6042 4 15.3787 4 15.1443C4.00104 14.9087 4.09231 14.6843 4.25203 14.5243L10.1015 8.00045L4.25203 1.47656C4.09231 1.31547 4.00104 1.09104 4 0.856628C4 0.621099 4.0892 0.396673 4.24788 0.234472C4.4076 0.0733769 4.62124 -0.0110572 4.84114 0.00116406C5.05998 0.014496 5.26431 0.123374 5.40535 0.303354L11.7776 7.4137C11.9456 7.60035 12.0245 7.8581 11.9933 8.11586V8.11615Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnMore);
export default __webpack_public_path__ + "static/media/icn_more.88f09b2f98af66238e151ebcad80185a.svg";
export { ForwardRef as ReactComponent };